const initialState = {
    chartZoom: {
        min: null,
        max: null,
        reset: false
    }
}

const types = {
    SYNC_ZOOM: 'components/chartwithsyncedzoom/SYNC_ZOOM'
};

export const reducers = {
    reducer(state = initialState, { type, payload }) {
        switch (type) {
            case types.SYNC_ZOOM: return { ...state, chartZoom: payload.chartZoom }
            default: return state;
        }
    }
}

export const actions = {
    syncZoom: (chartZoom) => ({ type: types.SYNC_ZOOM, payload: { chartZoom } })
}


// WEBPACK FOOTER //
// ./src/components/ReportComponents/Charts/ChartWithSyncedZoom/redux.js